import React, { Component } from "react";
import { Link } from "react-router-dom";

// import Loader
import Loader, { CircularLoader } from "./Loader";

class DashboardCourseOverviewLoader extends Component {
  componentDidMount() {
    // get global jQuery object for use within component
    this.$ = window.$;

    // configure course overview slider using local jQuery object
    this.$(this.courseOverviewSlider).owlCarousel({
      items: 4,
      loop: false,
      margin: 20,
      dots: false,
      navText: [
        "<i class='fa fa-long-arrow-left'></i>",
        "<i class='fa fa-long-arrow-right'></i>"
      ],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: true
        },
        480: {
          items: 1,
          nav: true
        },
        576: {
          items: 1,
          nav: true
        },
        768: {
          items: 2,
          nav: true
        },
        992: {
          items: 3,
          nav: true
        },
        1200: {
          items: 4,
          nav: false,
          loop: false
        }
      }
    });
  }
  render() {
    return (
      <div className="row no-gutters">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <div className="row no-gutters">
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                  Course Overview
                </div>
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">

                </div>
              </div>
            </div>
            <div className="card-body">
              <div
                className="course-overview-slider owl-carousel owl-theme"
                ref={el => (this.courseOverviewSlider = el)} // get reference to .course-overview-slider to configure the couse-overview-slider
              >
                <div className="course-overview text-center">
                  <div className="course-border">
                    <CircularLoader width="150" height="15" />
                    <div className="number mt-0">
                      <CircularLoader radius={35} />
                    </div>
                    <p>
                      <Loader height="50" width="700" />
                    </p>
                  </div>
                </div>
                <div className="course-overview text-center">
                  <div className="course-border">
                    <CircularLoader width="150" height="15" />
                    <div className="number mt-0">
                      <CircularLoader radius={35} />
                    </div>
                    <p>
                      <Loader height="50" width="700" />
                    </p>
                  </div>
                </div>
                <div className="course-overview text-center">
                  <div className="course-border">
                    <CircularLoader width="150" height="15" />
                    <div className="number mt-0">
                      <CircularLoader radius={35} />
                    </div>
                    <p>
                      <Loader height="50" width="700" />
                    </p>
                  </div>
                </div>
                <div className="course-overview text-center">
                  <div className="course-border">
                    <CircularLoader width="150" height="15" />
                    <div className="number mt-0">
                      <CircularLoader radius={35} />
                    </div>
                    <p>
                      <Loader height="50" width="700" />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* card for outstanding fees */}
          </div>
          {/* end card for course max/min credit unit, total registerable, c/o & outstanding courses  */}
        </div>
      </div>
    );
  }
}

export default DashboardCourseOverviewLoader;
